const relations = {
	description:
		"Hier können Sie Beziehungen erstellen und Produkte/Dienstleistungen mit diesen Beziehungen verknüpfen. Eine Beziehung kann ein Kunde von Ihnen oder eine Abteilung sein. Dadurch erhalten Sie eine Übersicht, welche Produkte zu welcher Beziehung gehören. Auch können die Daten einer Beziehung beispielsweise bei Domainnamen und SSL-Zertifikaten verwendet werden.",
	dialog_add: {
		description: "Eine neue Beziehung erstellen",
		input_description: {
			label: "Beziehungsbeschreibung",
			placeholder: "Geben Sie der Beziehung optional eine Beschreibung",
		},
		input_name: {
			label: "Beziehungsname",
			placeholder: "Geben Sie der Beziehung einen Namen",
		},
		messages: {
			success: "Beziehung <strong>{{relation_name}}</strong> wurde erfolgreich hinzugefügt!",
		},
		radio_is_business: {
			label: "Beziehungstyp",
			values: {
				business: "Geschäftlich",
				private: "Privat",
			},
		},
		title: "Neue Beziehung hinzufügen",
	},
	item: {
		add: {
			description:
				"Wählen Sie eine Beziehung aus, um sie mit Produkt <strong>{{service_name}}</strong/> zu verknüpfen",
			input_label: "Wählen Sie eine Beziehung",
			title: "Produktbeziehung hinzufügen",
		},
		delete: {
			description:
				"Sind Sie sicher, dass Sie die Verknüpfung mit Beziehung <strong>{{relation}}</strong> für Produkt <strong>{{service_name}}</strong> entfernen möchten?",
			not_found:
				"Wir konnten die Beziehung nicht finden. Bitte versuchen Sie es später noch einmal.",
			title: "Produkt von Beziehung trennen",
		},
	},
	overview_table: {
		empty: "Leer",
		head: {
			description: "Beschreibung",
			id: "ID",
			name: "Name",
			type: "Beziehungstyp",
		},
		relation_types: {
			business: "Geschäftlich",
			private: "Privat",
		},
	},
	service_type_list: {
		dadup: {
			no_dadup_connected: "Diese Beziehung hat keine verknüpften Dadup-Konten.",
			title: "daDup Storage",
		},
		domains: {
			no_domains_connected: "Diese Beziehung hat keine verbundenen Domains.",
			title: "Domainnamen",
		},
		pbs: {
			is_free_version: "Kostenlose Version",
			no_pbs_connected: "Diese Beziehung hat keine Tuxis PBS-Datenspeicher.",
			title: "Tuxis PBS",
		},
		qemu: {
			dialog_add: {
				description:
					"Wählen Sie hier einen oder mehrere VPSs aus, um sie mit der Beziehung zu verknüpfen.",
				relation_overwrite_warning:
					"Achtung! Dies wird von der Beziehung <strong>{{linked_relation_name}}</strong> getrennt.",
				title: "VPSs mit Beziehung verknüpfen",
			},
			dialog_add_select_multiple: {
				description:
					"Wählen Sie hier einen oder mehrere VPSs aus, um sie mit der Beziehung zu verknüpfen.",
				empty: "Es sind keine VPSs verfügbar, um sie mit der Beziehung zu verknüpfen.",
				linked_relation: "Derzeit mit dieser Beziehung verknüpft",
				title: "Verfügbare VPSs auswählen",
			},
			no_qemus_added: "Diese Beziehung hat keine verbundenen VPSs.",
			title: "VPSs",
		},
	},
	single: {
		delete: {
			button: "Beziehung löschen",
			description:
				"Sind Sie sicher, dass Sie die Beziehung <strong>{{relation}}</strong> löschen möchten? Die verknüpften Dienste werden getrennt.",
			status_message: {
				success: "Beziehung erfolgreich gelöscht",
			},
			title: "Beziehung löschen",
		},
		domain_details: {
			address_details: {
				country: "Land",
				title: "Adressdaten",
			},
			company_details: {
				title: "Unternehmensdetails",
			},
			contact_details: {
				title: "Personendaten",
			},
			description: "In diesem Abschnitt können Sie die Domaindetails der Beziehung ändern.",
			status_message: {
				success: "Domaindetails der Beziehung erfolgreich angepasst",
			},
			title: "Domaindetails",
			trademark_details: {
				title: "Markeninformationen (optional)",
			},
			warning_message: {
				cannot_edit:
					"Bitte beachten! Die Felder 'Vorname' 'Einfügung' 'Nachname' sind nach dem Speichern nicht editierbar. Bitte vergewissern Sie sich, dass die richtigen Daten vorhanden sind. Wenn Sie sie dennoch bearbeiten möchten, müssen Sie eine neue Beziehung erstellen.",
				cannot_edit_register_company:
					"Bitte beachten Sie! Die Felder 'Firmenname' sind nach dem Speichern nicht mehr editierbar. Vergewissern Sie sich, dass die richtigen Daten vorhanden sind.",
				cannot_edit_register_personal:
					"Bitte beachten! Die Felder 'Vorname' 'Einfügung' 'Nachname' sind nach dem Speichern nicht editierbar. Bitte vergewissern Sie sich, dass die richtigen Daten vorhanden sind.",
				cannot_edit2:
					"Bitte beachten Sie! Die Felder 'Firmenname' sind nach dem Speichern nicht mehr editierbar. Vergewissern Sie sich, dass die richtigen Daten vorhanden sind. Wenn Sie sie noch ändern möchten, müssen Sie eine neue Beziehung erstellen.",
				message:
					"Hinweis! Beim Speichern dieses Formulars werden die eingegebenen Informationen auf alle mit dieser Beziehung verbundenen Domain angewendet.",
			},
		},
		navbar: {
			information: "Informationen",
			overview: "Produkte & Dienstleistungen",
		},
		relation_details: {
			description:
				"In diesem Abschnitt können Sie den Namen und die Beschreibung der Beziehung ändern.",
			status_message: {
				success: "Beziehungsdetails erfolgreich angepasst",
			},
			title: "Beziehungsdetails",
		},
		title: "Beziehung",
	},
	title: "Beziehungen",
};

export default relations;
